<form [formGroup]="dateControlForm">
  <div class="flexCenterAlign">
    <mat-form-field class=" custom-mat-field">
      <input
        matInput
        readonly
        [matDatepickerFilter]="disableFutureDate"
        [placeholder]="placeHolder"
        [matDatepicker]="picker"
        formControlName="yearControl"
        [attr.id]="buildYearPickerId('fld-year')"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="picker"
        [attr.id]="buildYearPickerId('btn-toggle')">
        <img
          matDatepickerToggleIcon
          src="./assets/images/application-logos/svg/ic-calendar.svg"
        />
      </mat-datepicker-toggle>
      <mat-datepicker
        #picker
        (yearSelected)="calenderSelected($event, picker)"
        (viewChanged)="viewChanged(picker)"
        startView="multi-year"
      >
      </mat-datepicker>
    </mat-form-field>
  </div>
</form>
